/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_HeadingInputs */

const tr_mesafeli_s5_heading = /** @type {(inputs: Mesafeli_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Hizmet Bedeli ve Ödeme`)
};

const en_mesafeli_s5_heading = /** @type {(inputs: Mesafeli_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Service Fee and Payment`)
};

const de_mesafeli_s5_heading = /** @type {(inputs: Mesafeli_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Entgelt und Zahlung`)
};

const ru_mesafeli_s5_heading = /** @type {(inputs: Mesafeli_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Стоимость услуг и оплата`)
};

/**
* | output |
* | --- |
* | "5. Service Fee and Payment" |
*
* @param {Mesafeli_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_heading = /** @type {((inputs?: Mesafeli_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_heading(inputs)
	if (locale === "de") return de_mesafeli_s5_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s5_heading(inputs)
	return tr_mesafeli_s5_heading(inputs)
});